import Text12 from '@sdk/components/ui/typography/Text12';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { ButtonContainer } from '@web/timesheets/CreateTimesheetModal/components/buttons/buttons.styles';
import AddIconSvg from '@web/assets/svg/Icons/18/add.svg';

type Props = {
  label: string;
  onClick: VoidFunction;
};
const AddEntryButton = ({ label, onClick }: Props) => {
  return (
    <ButtonContainer onClick={onClick}>
      <AddIconSvg />
      <Text12 themeColor={ThemeColorType.iconGray} mLeft={5}>
        {label}
      </Text12>
    </ButtonContainer>
  );
};

export default AddEntryButton;
